






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EFacilityPaymentAccountStatus } from '@zunta/configurations'
import { EStatusType } from '@/components/statuses/EStatusType'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusWillowPaymentAccount extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.error
    }

    switch (this.$props.status) {
      case EFacilityPaymentAccountStatus.ACTIVE:
        return EStatusType.success
      case EFacilityPaymentAccountStatus.PENDING:
        return EStatusType.pending
      case EFacilityPaymentAccountStatus.ERROR:
        return EStatusType.error
      default:
        return EStatusType.error
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return 'Inactive'
    }
    const STATUS_LABEL_MAP: any = {
      [EFacilityPaymentAccountStatus.PENDING]: 'Initializing Account',
      [EFacilityPaymentAccountStatus.ACTIVE]: 'Active',
      [EFacilityPaymentAccountStatus.ERROR]: 'Inactive'
    }
    return STATUS_LABEL_MAP[this.$props.status]
  }
}
